import {PATH_SEP} from "~/constants";
import type {m_taxonomy} from "~/services/classes/TaxonomyClasses";

/**
 * Categories that stop above the taxonomy's depth (`size` levels): each as its labels from L1. The current
 * builder blocks sending for approval while there are any, unless the profile allows an incomplete taxonomy
 * (`TaxonomyManagerStore.incompleteCategories`). Unlike there, deleted categories are left out: a category
 * whose sub-categories were all deleted counts as stopping where it is.
 */
export function incompleteCategories(root: m_taxonomy.Tree, size: number): string[][] {
    const found: string[][] = [];
    const visit = (node: m_taxonomy.Tree, path: string[]) => {
        if (path.length >= size) return;
        const children = node.children.filter(c => !c.removed);
        if (children.length === 0) {
            if (path.length > 0) found.push(path);
            return;
        }
        children.forEach(c => visit(c, [...path, c.label]));
    };
    visit(root, []);
    return found.sort((a, b) => a.join(PATH_SEP).localeCompare(b.join(PATH_SEP)));
}

/** The deepest level any (not deleted) category reaches: 1 for L1; 0 when there are none. */
export function deepestLevel(root: m_taxonomy.Tree): number {
    const depth = (node: m_taxonomy.Tree): number =>
        Math.max(0, ...node.children.filter(c => !c.removed).map(c => 1 + depth(c)));
    return depth(root);
}
